import { Offering } from "./offering";
import offeringService from "./offeringsService";
import Event from "common/event";
import { ActionWithDispatch } from "common/actionWithDispatch";
import trackApiCall from "features/saveIndicator/trackApiCall";



export class OfferingsLoaded extends Event {
  constructor(public offerings: Offering[]) {
    super(OfferingsLoaded.EventName);
  }

  public static EventName: string = "OFFERINGS_LOADED";
}


export class OfferingUpdated extends Event {
  constructor(public offering: Offering) {
    super(OfferingUpdated.EventName);
  }

  public static EventName: string = "OFFERINGS_UPDATED";
}

export function loadOfferings(): ActionWithDispatch<OfferingsLoaded> {
  return function (dispatch) {
    return offeringService
      .listOfferings()
      .then(offerings => dispatch(new OfferingsLoaded(offerings).toObject()));
  };
}

export function updateOffering(newValue: Offering, oldValue: Offering): ActionWithDispatch<OfferingUpdated, void> {
  return trackApiCall(dispatch => {
    dispatch(new OfferingUpdated(newValue).toObject());
    return offeringService
      .updateOffering(newValue)
      .catch((error) => {
        dispatch(new OfferingUpdated(oldValue).toObject());
        throw error;
      });
  });
}


